// @flow
export const tabViewActions = {
  set_selected_tab: 'set_selected_tab'
};

export const setSelectedTab = (data: string) => ({
  type: tabViewActions.set_selected_tab,
  payload: data
});
